module.exports = __webpack_public_path__ + "img/welcome.574695a4.svg";